import axios from "axios";
import React, { useEffect, useState } from "react";
import { api_key, img_url, unavailable } from "../../Requests";
import { useContentStore, useModalStore } from "../../store";
import "./Modal.css";
import {useNavigate} from "react-router-dom"

function Modal() {
  const { setModalShow } = useModalStore();
  const { content } = useContentStore();
  let navigate = useNavigate()
  const [movies, setmovies] = useState();
  const [credits, setCredits] = useState([]);

  const fetchData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${content}?api_key=${api_key}&language=en-US`
    );

    setmovies(data);
  };
  const fetchCredits = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${content}/credits?api_key=${api_key}&language=en-US`
    );
    setCredits(data.cast);
    // console.log(data.cast);
  };
  useEffect(() => {
    fetchData();
    fetchCredits();

  }, []);
  return (
    <div className="modal">
      <div
        className="overlayDiv"
        onClick={() => {
          // console.log(movies, credits);
          setModalShow(false);
        }}
      ></div>
      <div className="modalDiv">
        {movies && (
          <div className="movieImgDiv">
            <img
              className="movieImg"
              src={
                movies.poster_path
                  ? `${img_url}/${movies.poster_path}`
                  : unavailable
              }
              alt={movies.name || movies.title}
            />
          </div>
        )}
        {movies && (
          <div className="movieTile">
            <h1 className="title">{movies.name || movies.title}</h1>
            <div className="description">
              <span className="contentDescription">
                {movies.overview}
                <br />
              </span>
            </div>
            <div className="cast">
              {credits &&
                credits.map((credit, i) => (
                  <button key={i} className="actors">
                    {" "}
                    {credit.name}
                  </button>
                ))}
            </div>
            <button className="book_btn" onClick={()=>{
              navigate(`/${movies.original_title}/select-seats`,{state:{id:1,movies:movies}})
              setModalShow(false)
            }}>{"Book Now >"}</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Modal;
